import { Textarea } from "@mantine/core";
import { useTaxOrganizerStore } from "../../../../../utils/stores/taxOrganizerStore";

interface AdditionalCommentsProps {
  parentObjectName: string;
}
/**
 * AdditionalComments component to capture any special circumstances or comments
 * from the user about their tax filing for the year. This comment is private
 * and only shared with the user's Tax Pro.
 *
 * @component
 * @returns {JSX.Element} The rendered JSX element
 */
const AdditionalComments = ({ parentObjectName }: AdditionalCommentsProps) => {
  // Extract responses and updateResponses from the Zustand store
  const { responses, updateResponses } = useTaxOrganizerStore();

  /**
   * Handles the change event for the textarea.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement>} event - The change event object.
   */
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    updateResponses({
      ...responses,
      comments: {
        ...(responses["comments"] ?? ""),
        [parentObjectName]: event.target.value,
      },
    });
  };

  return (
    <div className="additional-comments-container">
      <p>
        If you have any special circumstances around your tax filing for this
        year, you can leave a comment for your Tax Pro. Your comment is private
        and only shared with your Tax Pro.
      </p>
      <Textarea
        placeholder="Write your comments here"
        autosize
        minRows={8}
        maxRows={8}
        mb="lg"
        value={responses?.comments?.[parentObjectName] ?? ""}
        onChange={handleChange}
      />
    </div>
  );
};

export default AdditionalComments;
